import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryShowcase() {
  return (
    <section className="py-16 md:py-24 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <p className="text-xs tracking-widest uppercase text-secondary-500 font-medium mb-3 whitespace-nowrap">Explore</p>
          <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-950 mb-3">
            探索喵绅士世界
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto leading-relaxed">
            六大主题板块，带您全方位领略猫咪文化与精致生活的无限魅力
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative overflow-hidden rounded-lg aspect-[4/3] bg-background-200"
            >
              <img
                src={cat.imageUrl}
                alt={cat.name}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-black/20 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5">
                <div className="flex items-center gap-2 mb-1.5">
                  <div className="w-7 h-7 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center">
                    <i className={`${cat.icon} text-white text-sm w-4 h-4 flex items-center justify-center`} />
                  </div>
                  <h3 className="text-base md:text-lg font-heading font-semibold text-white whitespace-nowrap">{cat.name}</h3>
                </div>
                <p className="text-xs md:text-sm text-white/80 line-clamp-2 leading-relaxed">{cat.description}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}